<template>
    <div>
        <div class="row mb-2">
            <div class="col-auto">
                <h4>Aggiungi nuovo media</h4>
            </div>
        </div>
        <div class="row">
            <b-form-group
                label="File"
                label-for="mediaFile"
                class="col-auto"
            >
                <b-form-file
                    id="mediaFile"
                    v-model="file"
                    placeholder="Scegli file"
                    drop-placeholder="Rilascia il file"
                ></b-form-file>
            </b-form-group>

            <b-form-group
                label="Chiave"
                label-for="fileKey"
                class="col-auto"
            >
                <b-form-input v-model="key" placeholder="Chiave"></b-form-input>
            </b-form-group>

            <div class="col-auto d-flex flex-column justify-content-end mb-3">
                <b-button variant="primary" @click.prevent="add">Aggiungi</b-button>
            </div>
        </div>
        <!--
        <div class="row" wire:loading wire:target="file">
            <div class="col-auto">
                Caricamento...
            </div>
        </div>
        -->
    </div>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "UploadMedia",
    data() {
        return {
            file: null,
            key: '',
        }
    },
    props: {
        eventId: String
    },
    methods: {
        add() {
            this.$apollo.mutate({
                mutation: gql`mutation ($eventId: ID!, $key: String!, $file: Upload!) {
                        addMediaToEvent(eventId: $eventId, key: $key, file: $file) {
                            id
                        }
                    }`,
                variables: {
                    eventId: this.eventId,
                    key: this.key,
                    file: this.file
                },
                refetchQueries: [
                    'GetEvent'
                ]
            }).then((data) => {
                this.file = null;
                this.key = '';
            }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>

<style scoped>

</style>
